import { render, staticRenderFns } from "./CreateUblArchiveModalCreated.vue?vue&type=template&id=e6c9b99c&scoped=true"
import script from "./CreateUblArchiveModalCreated.vue?vue&type=script&lang=ts"
export * from "./CreateUblArchiveModalCreated.vue?vue&type=script&lang=ts"
import style0 from "./CreateUblArchiveModalCreated.vue?vue&type=style&index=0&id=e6c9b99c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c9b99c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6c9b99c')) {
      api.createRecord('e6c9b99c', component.options)
    } else {
      api.reload('e6c9b99c', component.options)
    }
    module.hot.accept("./CreateUblArchiveModalCreated.vue?vue&type=template&id=e6c9b99c&scoped=true", function () {
      api.rerender('e6c9b99c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreateUblArchiveModalCreated.vue"
export default component.exports